<template>
    <ul class="manual-tree">
        <li v-for="node in nodes" :key="node.uid">
            <button
                type="button"
                class="manual-tree__item"
                :aria-current="node.uid === currentUid ? 'page' : undefined"
                @click="$emit('select', node.uid)"
            >
                {{ node.title }}
            </button>
            <div v-if="node.children.length" class="manual-tree__children">
                <ManualTree :nodes="node.children" :current-uid="currentUid" @select="$emit('select', $event)" />
            </div>
        </li>
    </ul>
</template>

<script setup lang="ts">
import type { ManualTreeNode } from '@src/Manual/Pages/composables/useManualDrawer';

defineProps<{ nodes: ManualTreeNode[]; currentUid?: string | null }>();
defineEmits<{ select: [uid: string] }>();
</script>

<style scoped>
.manual-tree {
    list-style: none;
    margin: 0;
    padding: 0;
}
.manual-tree__item {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0.25rem 0;
}
.manual-tree__item:hover {
    text-decoration: underline;
}
.manual-tree__item[aria-current='page'] {
    font-weight: 600;
}
.manual-tree__children {
    padding-left: 0.75rem;
    border-left: 1px solid rgba(128, 128, 128, 0.2);
}
</style>
